module.exports = __webpack_public_path__ + "static/media/proxxmu-wfscenarios.b5ac3648.png";